import { apiRequest } from './apiClient';

export async function getStudentHomeworks() {
  const response = await apiRequest('/student/homeworks');

  return response.data || [];
}

export async function getStudentHomeworkById(homeworkId) {
  const response = await apiRequest(`/student/homeworks/${homeworkId}`);

  return response.data || null;
}

export async function submitStudentHomework(homeworkId, answers) {
  const response = await apiRequest(`/student/homeworks/${homeworkId}/submit`, {
    method: 'POST',
    body: { answers },
  });

  return response.data || null;
}
